import {ProductsListSortingCols} from '@em/shared/api-interface';
import {SORTABLE_COLUMNS} from '../sortable-columns';

export function isSortableColumn(val: string): val is ProductsListSortingCols {
  return (SORTABLE_COLUMNS as string[]).includes(val);
}
